export const updateFilters = (set) => (filters, options) => {
  set({
    filters,
    page: 1,
    ...options,
  });
};
